const pad = (value) => String(Math.max(0, value)).padStart(2, '0')

const updateCountdown = (node, targetDate) => {
  const now = new Date()
  const diff = Math.max(0, targetDate.getTime() - now.getTime())

  const totalSeconds = Math.floor(diff / 1000)
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const dayNode = node.querySelector('[data-countdown-days]')
  const hourNode = node.querySelector('[data-countdown-hours]')
  const minuteNode = node.querySelector('[data-countdown-minutes]')
  const secondNode = node.querySelector('[data-countdown-seconds]')

  if (dayNode) dayNode.textContent = pad(days)
  if (hourNode) hourNode.textContent = pad(hours)
  if (minuteNode) minuteNode.textContent = pad(minutes)
  if (secondNode) secondNode.textContent = pad(seconds)
}

const initEventCountdown = () => {
  const countdowns = document.querySelectorAll('[data-event-countdown]')

  if (!countdowns.length) {
    return
  }

  countdowns.forEach((countdown) => {
    const target = countdown.getAttribute('data-target')

    if (!target) {
      return
    }

    const targetDate = new Date(target)

    if (Number.isNaN(targetDate.getTime())) {
      return
    }

    updateCountdown(countdown, targetDate)

    window.setInterval(() => {
      updateCountdown(countdown, targetDate)
    }, 1000)
  })
}

export default initEventCountdown



// WEBPACK FOOTER //
// ./resources/assets/js/components/event-countdown.js